export class TimerManager {
  private intervalMs: number = 0;
  private remainingMs: number = 0;
  private timerId: ReturnType<typeof setInterval> | null = null;
  private _isRunning: boolean = false;
  private _isPaused: boolean = false;
  private lastTickTime: number = 0;

  onTick: ((remainingSeconds: number) => void) | null = null;
  onExpired: (() => void) | null = null;

  start(intervalSeconds: number): void {
    this.stop();
    this.intervalMs = intervalSeconds * 1000;
    this.remainingMs = this.intervalMs;
    this._isRunning = true;
    this._isPaused = false;
    this.lastTickTime = Date.now();
    this.startInterval();
  }

  pause(): void {
    if (!this._isRunning || this._isPaused) return;
    this._isPaused = true;
    this.clearInterval();
    // Capture remaining time
    const elapsed = Date.now() - this.lastTickTime;
    this.remainingMs = Math.max(0, this.remainingMs - elapsed);
  }

  resume(): void {
    if (!this._isRunning || !this._isPaused) return;
    this._isPaused = false;
    this.lastTickTime = Date.now();
    this.startInterval();
  }

  reset(): void {
    if (!this._isRunning) return;
    this.clearInterval();
    this.remainingMs = this.intervalMs;
    this._isPaused = false;
    this.lastTickTime = Date.now();
    this.startInterval();
  }

  stop(): void {
    this.clearInterval();
    this._isRunning = false;
    this._isPaused = false;
    this.remainingMs = 0;
  }

  getRemainingMs(): number {
    if (!this._isRunning) return 0;
    if (this._isPaused) return this.remainingMs;
    const elapsed = Date.now() - this.lastTickTime;
    return Math.max(0, this.remainingMs - elapsed);
  }

  isRunning(): boolean {
    return this._isRunning;
  }

  isPaused(): boolean {
    return this._isPaused;
  }

  private startInterval(): void {
    this.timerId = setInterval(() => {
      const now = Date.now();
      const elapsed = now - this.lastTickTime;
      this.remainingMs = Math.max(0, this.remainingMs - elapsed);
      this.lastTickTime = now;

      if (this.remainingMs <= 0) {
        this.clearInterval();
        this._isRunning = false;
        this._isPaused = false;
        if (this.onExpired) {
          this.onExpired();
        }
      } else {
        if (this.onTick) {
          this.onTick(Math.ceil(this.remainingMs / 1000));
        }
      }
    }, 1000);
  }

  private clearInterval(): void {
    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }
}
